import Nav from "../components/Nav"
import Footer from "../components/Footer"
import Container from "../components/core/Container"
import SectionTag from "../components/core/SectionTag"
import { nabidka } from "../courses/nabidka"
import { lecturers } from "../lecturers/lecturers"
import { useSearchParams } from "react-router-dom"
import Paragraph from "../components/core/Paragraph"
import { useCallback, useEffect, useState } from "react"
import Image from "../components/core/Image"
import Heading from "../components/core/Heading"
import Button from "../components/core/Button"
import { useNavigate } from "react-router-dom"
import SEO from "../components/SEO"
import Link from "../components/core/Link"
import { subscribeNewsletter } from "../api/send/subcribe_newsletter"
import { sendRegistrationEmail } from "../api/send/application"
import { sendRegistrationNotifyEmail } from "../api/send/application_notify"
import InfoPopUp from "../components/pop_up/InfoPopUp"

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function NabidkaClickedPage() {
    const [searchParams] = useSearchParams();
    const id = searchParams.get('id');
    const [entity, setEntity] = useState(null)
    const [lecturer, setLecturer] = useState(null)
    const [freeSignupLoading, setFreeSignupLoading] = useState(false)
    const [isInfoPopUpOpen, setIsInfoPopUpOpen] = useState(false)
    const [infoPopUpTitle, setInfoPopUpTitle] = useState("")
    const [infoPopUpText, setInfoPopUpText] = useState("")
    const [infoPopUpType, setInfoPopUpType] = useState("success")

    const navigate = useNavigate();

    const handlePrihlaseniClick = (id) => {
        navigate(`/prihlaseni_kurz?id=${id}`)
    }

    const handleFreePrihlaseni = useCallback(async (e) => {
        e.preventDefault();
        if (!entity || !lecturer) return;

        const emailRaw = (e.target.email?.value || "").trim();
        if (!emailRaw || !EMAIL_RE.test(emailRaw)) {
            setInfoPopUpType("error");
            setInfoPopUpTitle("Neplatný e-mail");
            setInfoPopUpText("Zadejte prosím platnou e-mailovou adresu.");
            setIsInfoPopUpOpen(true);
            return;
        }

        const lecturerFullName = `${lecturer.before_name} ${lecturer.name} ${lecturer.surname} ${lecturer.after_name}`.replace(/\s+/g, " ").trim();

        const coursePayload = {
            free_course_signup: true,
            course_id: entity.id,
            course: entity.name,
            course_description: entity.description,
            realization_date: entity.realization_date,
            format: entity.format,
            location: entity.location,
            live_price: entity.live_price,
            email: emailRaw,
            lecturer: lecturerFullName,
            lecturer_id: entity.lecturer,
            newsletter: true,
        };

        setFreeSignupLoading(true);
        try {
            const subResult = await subscribeNewsletter({ email: emailRaw });

            await sendRegistrationEmail(coursePayload);
            let notifyOk = true;
            try {
                await sendRegistrationNotifyEmail(coursePayload);
            } catch (notifyErr) {
                notifyOk = false;
                console.error("Chyba při odesílání potvrzení účastníkovi:", notifyErr);
            }

            let detail = "";
            if (subResult && subResult.ok === false && subResult.message) {
                detail = " Tento e-mail je již v našem newsletteru; přihlášku na kurz jsme přesto zaznamenali.";
            }

            setInfoPopUpType("success");
            setInfoPopUpTitle("Přihláška odeslána");
            setInfoPopUpText(
                notifyOk
                    ? `Děkujeme za bezplatnou přihlášku. Potvrzení jsme odeslali na ${emailRaw}.${detail}`
                    : `Vaši bezplatnou přihlášku jsme zaznamenali.${detail} Pokud vám nepřijde potvrzovací e-mail, kontaktujte nás prosím.`
            );
            setIsInfoPopUpOpen(true);
            e.target.reset();
        } catch (err) {
            console.error("Chyba při bezplatné přihlášce:", err);
            setInfoPopUpType("error");
            setInfoPopUpTitle("Odeslání se nezdařilo");
            setInfoPopUpText(
                err?.message || "Nepodařilo se dokončit přihlášku. Zkuste to prosím znovu nebo nás kontaktujte."
            );
            setIsInfoPopUpOpen(true);
        } finally {
            setFreeSignupLoading(false);
        }
    }, [entity, lecturer])

    useEffect(() => {
        if (id) {
            const foundEntity = nabidka.find(course => course.id === parseInt(id));
            console.log('Found entity:', foundEntity);
            if (foundEntity) {
                setEntity(foundEntity);
                const foundLecturer = lecturers.find(lec => lec.id === foundEntity.lecturer);
                console.log('Found lecturer:', foundLecturer, 'Looking for:', foundEntity.lecturer);
                if (foundLecturer) {
                    setLecturer(foundLecturer);
                } else {
                    console.error('Lecturer not found for:', foundEntity.lecturer);
                }
            } else {
                console.error('Entity not found for id:', id);
            }
        }
    }, [id])

    if (!entity) {
        return(
            <Container className="min-h-screen flex flex-col mb-12">
                <Nav/>
                <Container className="w-full max-w-7xl mx-auto mt-8 md:mt-12 px-4 mb-32">
                    <SectionTag>Kurz nenalezen</SectionTag>
                    <Paragraph variant="lead_black">Kurz s ID {id} nebyl nalezen.</Paragraph>
                    <Paragraph variant="lead_black">Nejspíše jste se snažili přejít na stránku kurzu, který neexistuje. Můžete se vrátit na <Link to="/kurzy">stránku s kurzy</Link> a vybrat si jiný kurz.</Paragraph>
                    <Button
                        variant="primary"
                        size="lg"
                        className="w-full text-lg py-3 shadow-lg hover:shadow-xl transition-shadow"
                        onClick={() => navigate('/kurzy')}
                    >
                        Zpět na stránku s kurzy
                    </Button>
                </Container>
                <Footer/>
            </Container>
        )
    }

    if (!lecturer) {
        return(
            <Container className="min-h-screen flex flex-col">
                <Nav/>
                <Container className="w-full mx-auto mt-8 md:mt-12 px-4">
                    <SectionTag>{entity.name}</SectionTag>
                    <Paragraph variant="lead_black">Lektor pro tento kurz nebyl nalezen.</Paragraph>
                </Container>
                <Footer/>
            </Container>
        )
    }

    const lecturerName = `${lecturer.before_name} ${lecturer.name} ${lecturer.surname} ${lecturer.after_name}`

    // Strukturovaná data pro detail kurzu
    const structuredData = {
        "@context": "https://schema.org",
        "@type": "Course",
        "name": entity.name,
        ...(entity.description && { "description": entity.description }),
        "provider": {
            "@type": "EducationalOrganization",
            "name": "digibezstresu"
        },
        ...(entity.format && { "courseMode": entity.format === "Online" ? "online" : "onsite" }),
        ...(entity.location && {
            "location": {
                "@type": "Place",
                "name": entity.location
            }
        }),
        ...(entity.realization_date && { "startDate": entity.realization_date }),
        ...(entity.live_price && {
            "offers": {
                "@type": "Offer",
                "price": entity.live_price,
                "priceCurrency": "CZK",
                "availability": entity.is_available ? "https://schema.org/InStock" : "https://schema.org/OutOfStock"
            }
        }),
        ...(entity.thumbnail && { "image": `${process.env.REACT_APP_SITE_URL || "https://digibezstresu.cz"}/courses_icons/${entity.thumbnail}` }),
        "instructor": {
            "@type": "Person",
            "name": lecturerName
        }
    };

    const handleCloseInfoPopUp = () => {
        setIsInfoPopUpOpen(false);
    };

    return(
        <>
            <SEO
                title={`${entity.name} - digibezstresu`}
                description={entity.description ? (entity.description.length > 160 ? entity.description.substring(0, 157) + "..." : entity.description) : ""}
                keywords={`${entity.name}${entity.format ? `, ${entity.format} kurz` : ""}, vzdělávací kurz, ${lecturerName}`}
                url={`/nabidka?id=${entity.id}`}
                type="article"
                image={entity.thumbnail ? `/courses_icons/${entity.thumbnail}` : ""}
                structuredData={structuredData}
            />
            <Container className="min-h-screen flex flex-col">
                <Nav/>
            <Container className="w-full max-w-7xl mx-auto mt-8 md:mt-12 px-4 pb-12">
                {/* Section Tag */}
                <Container bgColor="transparent" className="mb-8">
                    <SectionTag className="mb-4">{entity.name}</SectionTag>
                </Container>

                {/* Hlavní obsah - grid */}
                <Container bgColor="transparent" className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8">
                    {/* Levý sloupec – kurz, popis, CTA pod sebou */}
                    <Container bgColor="transparent" className="lg:col-span-2 space-y-6">
                        {/* Obrázek kurzu & základní informace */}
                        <Container bgColor="white" className="rounded-2xl shadow-lg overflow-hidden">
                            <Container bgColor="transparent" className="grid grid-cols-1 md:grid-cols-[30%_70%] gap-6 p-6">
                                {entity.thumbnail && (
                                    <Container bgColor="transparent" className="border-2 border-gray-200 rounded-xl overflow-hidden flex items-center justify-center p-4">
                                        <Image 
                                            src={`courses_icons/${entity.thumbnail}`} 
                                            alt={`${entity.name} thumbnail`} 
                                            className="w-48 h-auto object-contain sm:w-64"
                                        />
                                    </Container>
                                )}
                                <Container bgColor="transparent" className="flex flex-col gap-4">
                                    <Heading variant="h2" className="mb-2">{entity.name}</Heading>
                                    {(entity.format || entity.location || entity.realization_date) && (
                                        <Container bgColor="transparent" className="flex flex-wrap gap-4">
                                            {entity.format && (
                                                <Container bgColor="transparent" className="flex items-center gap-2">
                                                    <svg className="w-5 h-5 text-main" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                                    </svg>
                                                    <span className="text-gray-700 font-medium">{entity.format}</span>
                                                </Container>
                                            )}
                                            {entity.location && (
                                                <Container bgColor="transparent" className="flex items-center gap-2">
                                                    <svg className="w-5 h-5 text-main" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                                    </svg>
                                                    <span className="text-gray-700 font-medium">{entity.location}</span>
                                                </Container>
                                            )}
                                            {entity.realization_date && (
                                                <Container bgColor="transparent" className="flex items-center gap-2">
                                                    <svg className="w-5 h-5 text-main" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                                    </svg>
                                                    <span className="text-gray-700 font-medium">{entity.realization_date}</span>
                                                </Container>
                                            )}
                                        </Container>
                                    )}
                                    {Number(entity.live_price) > 0 ? (
                                        <Container bgColor="transparent" className="mt-4 pt-4 border-t border-gray-200">
                                            <Container bgColor="transparent" className="flex items-baseline gap-2">
                                                <span className="text-3xl font-bold text-main">{entity.live_price} Kč</span>
                                                <span className="text-gray-500 text-sm">/ kurz</span>
                                            </Container>
                                        </Container>
                                    ) : (
                                        <Container bgColor="transparent" className="mt-4 pt-4 border-t border-gray-200">
                                            <Container bgColor="transparent" className="flex items-baseline gap-2">
                                                <span className="text-3xl font-bold text-main">ZDARMA</span>
                                            </Container>
                                        </Container>
                                    )}
                                </Container>
                            </Container>
                        </Container>

                        {/* Popis kurzu */}
                        {entity.description && (
                            <Container bgColor="white" className="rounded-2xl shadow-lg p-6">
                                <Heading variant="h3" className="mb-4">O kurzu</Heading>
                                <Paragraph variant="lead_black" className="text-gray-700 leading-relaxed">
                                    {entity.description}
                                </Paragraph>
                            </Container>
                        )}

                        {/* Obsah kurzu */}
                        {entity.content_list && entity.content_list.length > 0 && (
                            <Container bgColor="white" className="rounded-2xl shadow-lg p-6">
                                <Heading variant="h3" className="mb-4">Obsah kurzu</Heading>
                                <Container className="text-lg mb-3 text-black text-gray-700 leading-relaxed">
                                    {entity.content_list.map((item, index) => (
                                        <Container key={index} bgColor="transparent" className="rounded-lg border border-gray-200 p-4 mb-4">
                                            <Heading variant="h4" className="mb-2">{'#' + (index + 1)} {item.heading}</Heading>
                                            <Paragraph variant="lead_black" className="text-gray-700 leading-relaxed">{item.description}</Paragraph>
                                            {item.link && (
                                                <a href={`${item.link}`} target="_blank" rel="noopener noreferrer" className="text-main hover:text-main_dark transition-colors">Odkaz</a>
                                            )}
                                        </Container>
                                    ))}
                                </Container>
                            </Container>
                        )}

                        {/* Ukázky kurzu */}
                        {entity.sample && entity.sample.length > 0 && (
                            <Container bgColor="white" className="rounded-2xl shadow-lg p-6">
                                <Heading variant="h3" className="mb-4">Ukázky kurzu</Heading>
                                <Container className="text-lg mb-3 text-black text-gray-700 leading-relaxed">
                                    {entity.sample.map((item, index) => (
                                        <Container key={index} bgColor="transparent" className="rounded-lg border border-gray-200 p-4 mb-4">
                                            <Heading variant="h4" className="mb-2">{'#' + (index + 1)} {item.heading}</Heading>
                                            <Paragraph variant="lead_black" className="text-gray-700 leading-relaxed">{item.description}</Paragraph>
                                            {item.link && (
                                                <a href={`${item.link}`} target="_blank" rel="noopener noreferrer" className="text-main hover:text-main_dark transition-colors">Odkaz</a>
                                            )}
                                        </Container>
                                    ))}
                                </Container>
                            </Container>
                        )}

                        {/* Poznámky kurzu */}
                        {entity.note && entity.note.length > 0 && (
                            <Container bgColor="white" className="rounded-2xl shadow-lg p-6">
                                <Heading variant="h3" className="mb-4">Poznámky kurzu</Heading>
                                <Container className="text-lg mb-3 text-black text-gray-700 leading-relaxed">
                                    {entity.note.map((item, index) => (
                                        <Container 
                                            key={index} 
                                            bgColor={item.type === "info" ? "main_light" : item.type === "warning" ? "yellow-100" : "transparent"} 
                                            className={`rounded-lg border border-gray-200 p-4 mb-4`}
                                        >
                                            <Heading variant="h4" className="mb-2">{'#' + (index + 1)} {item.heading}</Heading>
                                            <Paragraph variant="lead_black" className="text-gray-700 leading-relaxed">{item.description}</Paragraph>
                                        </Container>
                                    ))}
                                </Container>
                            </Container>
                        )}



                        {/* CTA – přihlášení - je dostupný a není zdarma */}
                        {entity.is_available && Number(entity.live_price) > 0 && (<Container bgColor="transparent" className="rounded-2xl shadow-xl p-6">
                            <Heading variant="h3" className="mb-3">Přihlášení na kurz</Heading>
                            <Paragraph variant="lead_black">
                                Zajistěte si místo a začněte se vzdělávat bez stresu už dnes.
                            </Paragraph>
                            <Button
                                variant="primary"
                                size="lg"
                                className="w-full text-lg py-3 shadow-lg hover:shadow-xl transition-shadow"
                                onClick={() => handlePrihlaseniClick(entity.id)}
                            >
                                Přihlásit se na kurz
                            </Button>
                        </Container>)}

                        {/* CTA – přihlášení - je dostupný a je zdarma */}
                        {entity.is_available && Number(entity.live_price) === 0 && (<Container bgColor="transparent" className="rounded-2xl shadow-xl p-6">
                            <Heading variant="h3" className="mb-3">Přihlášení na kurz</Heading>
                            <Paragraph variant="lead_black">
                                Jediná podmínka k vytvoření přihlášky je zapojení do našeho newsletteru. Proto musíte níže vložit svůj email, kterým Vám budeme zasílat novinky formou měsíční nabídky. Zároveň Vám na tento email zašleme informace k samotné realizaci.
                            </Paragraph>
                            <Container bgColor="transparent" className="mb-4 mt-2">
                                <Paragraph variant="xs_gray">
                                    Pro vytvoření přihlášky musíte souhlasit se{" "}
                                    <Link to="/podminky_zpracovani" variant="primary">
                                        zpracováním osobních údajů
                                    </Link>{" "}
                                    a s{" "}
                                    <Link to="/obchodni_podminky" variant="primary">
                                        obchodními podmínkami
                                    </Link>
                                    .
                                </Paragraph>
                            </Container>

                            <form onSubmit={handleFreePrihlaseni} action="#" method="POST">
                                <Container className="flex flex-col gap-2 mb-4" bgColor="transparent">
                                    <label className="font-medium text-gray-800">Email pro odběr nabídky</label>
                                    <input required id="email" type="email" name="email" autoComplete="email" placeholder="Zadejte svůj email" className="bg-white/90 border-2 border-gray-300 rounded-xl py-2 px-4 focus:border-main focus:bg-white focus:shadow-lg focus:outline-none transform hover:-translate-y-1 transition-all duration-300"></input>
                                </Container>

                                <Container className="flex flex-col sm:flex-row sm:items-center gap-3 pb-5" bgColor="transparent">
                                    <Container className="flex items-start gap-2 sm:items-center">
                                        <input id="podminky_gdpr" name="podminky_gdpr" type="checkbox" required className="w-5 h-5 mt-1 sm:mt-0 text-main border-gray-300 rounded focus:ring-main focus:ring-2 flex-shrink-0"></input>
                                        <span className="text-gray-800 text-sm sm:text-base">Prohlašuji, že jsem se seznámil/a se zásadami zpracování osobních údajů.</span>
                                    </Container>
                                    <Link to="/podminky_zpracovani" variant="primary" className="whitespace-nowrap text-sm sm:text-base sm:ml-auto">Zobrazit zásady</Link>
                                </Container>

                                <Container className="flex flex-col sm:flex-row sm:items-center gap-3 pb-5" bgColor="transparent">
                                    <Container className="flex items-start gap-2 sm:items-center">
                                        <input id="podminky_obchod" name="podminky_obchod" type="checkbox" required className="w-5 h-5 mt-1 sm:mt-0 text-main border-gray-300 rounded focus:ring-main focus:ring-2 flex-shrink-0"></input>
                                        <span className="text-gray-800 text-sm sm:text-base">Souhlasím s obchodními podmínkami a podmínkami účasti na vzdělávací akci.</span>
                                    </Container>
                                    <Link to="/obchodni_podminky" variant="primary" className="whitespace-nowrap text-sm sm:text-base sm:ml-auto">Zobrazit smluvní podmínky</Link>
                                </Container>

                                <Button
                                    type="submit"
                                    variant="primary"
                                    size="lg"
                                    disabled={freeSignupLoading}
                                    className="w-full text-lg py-3 shadow-lg hover:shadow-xl transition-shadow disabled:opacity-60 disabled:cursor-not-allowed"
                                >
                                    {freeSignupLoading ? "Odesílám…" : "Přihlásit se na kurz bezplatně"}
                                </Button>
                            </form>

 

                            
                        </Container>)}
                    </Container>

                    {/* Pravý sloupec – karta lektora (na mobilu pod obsahem, na lg vpravo, bez natažení na výšku zbytku) */}
                    <Container bgColor="white" className="rounded-2xl shadow-lg p-6 lg:col-span-1 lg:self-start lg:max-w-sm lg:ml-auto">
                        <Heading variant="h3" className="mb-4">Lektor kurzu</Heading>
                        <Container bgColor="transparent" className="flex flex-col items-center gap-4">
                            <Container bgColor="gray-100" className="rounded-full overflow-hidden w-24 h-24 flex items-center justify-center">
                                <Image 
                                    src={lecturer.image} 
                                    alt={lecturerName}
                                    className="w-full h-full object-cover"
                                />
                            </Container>
                            <Container bgColor="transparent" className="text-center">
                                <Heading variant="h4" className="mb-2">{lecturerName}</Heading>
                                <span className="block text-gray-600 text-sm leading-relaxed text-justify">
                                    {lecturer.description}
                                </span>
                            </Container>
                        </Container>
                    </Container>
                </Container>
            </Container>
            <Footer/>
        </Container>
            {isInfoPopUpOpen && (
                <InfoPopUp
                    title={infoPopUpTitle}
                    text={infoPopUpText}
                    type={infoPopUpType}
                    onClick={handleCloseInfoPopUp}
                />
            )}
        </>
    )
}